<template>
  <h5 class="my-3 text-center">
    {{ $t('subtitle') }}
  </h5>
  <div class="row g-3 my-3">
    <div
      class="col col-sm-6 col-md-4 col-lg-3"
      v-for="topic of this.topics"
      :key="topic.name"
    >
      <div class="p-4 w-100 h-100 btn btn-outline-dark">
        <div
          class="text-center"
          @click="$emit('topicSelected', topic.name)"
        >
          <i class="fas topic-icon h1" :class="topic.icon" />
          <div class="mt-3 h5">
            {{ $t(topic.name) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { components } from 'locales';

export default {
  name: 'SupportTopicPicker',
  i18n: components.support.SupportTopicPicker,
  emits: ['topicSelected'],
  data() {
    return {
      topics: [
        {
          icon: 'fa-box',
          name: 'board_order',
        },
        {
          icon: 'fa-cubes',
          name: 'assembly_order',
        },
        {
          icon: 'fa-object-group',
          name: 'new_assembly',
        },
        {
          icon: 'fa-file-invoice',
          name: 'invoice',
        },
        {
          icon: 'fa-industry',
          name: 'manufacturing_defects',
        },
        {
          icon: 'fa-drafting-compass',
          name: 'design',
        },
        {
          icon: 'fa-user-circle',
          name: 'account',
        },
        {
          icon: 'fa-laptop-code',
          name: 'website',
        },
        {
          icon: 'fa-mail-bulk',
          name: 'feedback',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>

</style>
